/**
 * Human-readable sidebar preview for chat messages (including [SYSTEM] events).
 */
export function formatChatMessagePreview(content) {
  if (!content || typeof content !== "string") return content || "";
  if (!content.startsWith("[SYSTEM]")) return content;
  try {
    const event = JSON.parse(content.slice(8));
    if (event.event === "member_removed" && event.removedUserName && event.removedByUserName) {
      return `${event.removedUserName} was removed by ${event.removedByUserName}`;
    }
    if (event.event === "member_left" && event.leftUserName) {
      return `${event.leftUserName} left the group`;
    }
    if (event.event === "member_added" && event.addedUserName && event.addedByUserName) {
      return `${event.addedUserName} was added by ${event.addedByUserName}`;
    }
    if (event.removedUserName) return `${event.removedUserName} was removed`;
    if (event.addedUserName) return `${event.addedUserName} was added`;
    return "Group update";
  } catch {
    return "Group update";
  }
}
